/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface FileUploadResponse {
  fileKey: string;
  fileUrl: string;
}

export interface GetUsersResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    subscriptions?: {
      id: string;
      studentId: string;
      subjectTitle: string;
    }[];
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetUserByIdResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  } & {
    marketingConsent: boolean;
  };
}

export interface GetUserAvatarsResponse {
  data: {
    /** @format uuid */
    id: string;
    avatarS3Url: string;
  }[];
}

export interface UpdateUserAvatarResponse {
  data: {
    message: string;
  };
}

export interface GetUserDetailsResponse {
  data: {
    firstName: string | null;
    lastName: string | null;
    /** @format uuid */
    id: string;
    description: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    jobTitle: string | null;
    userAvatarId: string;
    guardian: {
      /** @format uuid */
      guardianId: string;
      guardianFirstName: string;
      guardianLastName: string;
      guardianEmail: string;
    } | null;
  };
}

export interface UpdateUserBody {
  firstName?: string;
  lastName?: string;
  /** @format email */
  email?: string;
  role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  archived?: boolean;
}

export interface UpdateUserResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  };
}

export interface UpsertStudentDetailsBody {
  firstName: string;
  lastName: string;
  username: string;
  marketingConsent: boolean;
}

export interface UpsertStudentDetailsResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpsertUserDetailsBody {
  description?: string;
  /** @format email */
  contactEmail?: string;
  contactPhoneNumber?: string;
  jobTitle?: string;
}

export interface UpsertUserDetailsResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface AdminUpdateUserBody {
  firstName?: string;
  lastName?: string;
  role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  hasFreeAccess?: boolean;
  bannedAt?: string | null;
  bannedReason?: string | null;
  isActive?: boolean;
  marketingConsent?: boolean;
}

export interface AdminUpdateUserResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  } & {
    marketingConsent: boolean;
  };
}

export interface BanUserBody {
  userId: string;
  bannedAt: string | null;
  bannedReason: string | null;
}

export interface BanUserResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface ChangePasswordBody {
  /**
   * @minLength 8
   * @maxLength 64
   */
  newPassword: string;
  /**
   * @minLength 8
   * @maxLength 64
   */
  oldPassword: string;
}

export type ChangePasswordResponse = null;

export interface ArchiveUserResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type DeleteUserResponse = null;

export interface DeleteBulkUsersBody {
  userIds: string[];
}

export type DeleteBulkUsersResponse = null;

export interface CreateUserBody {
  /** @format email */
  email: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  lastName: string;
  role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
}

export interface CreateUserResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface GetAllSubjectsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSubjectByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  };
}

export interface CreateSubjectBody {
  title: string;
}

export interface CreateSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateSubjectBody {
  /** @format uuid */
  id?: string;
  title?: string;
  archived?: boolean;
}

export interface UpdateSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  };
}

export interface GetAllCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorEmail?: string;
    subject: string;
    chapters?: {
      /** @format uuid */
      id: string;
      title: string;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ";
        description?: string | null;
        status?: string;
        displayOrder: number;
        fileUrl?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "scale_1_5"
            | "single_choice"
            | "free_choice"
            | "multiple_choice"
            | "true_or_false"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd"
            | "sorting";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string | null;
          photoS3Key?: string | null;
          options?: {
            /** @format uuid */
            id?: string;
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean;
            /** @format uuid */
            questionId?: string;
            scaleAnswer?: number | null;
          }[];
        }[];
        /** @format date-time */
        updatedAt?: string;
        highlights?: {
          /** @format uuid */
          id?: string;
          title: string;
          photoS3Key?: string;
          photoS3Url?: string;
          timestamp: number;
        }[];
        additionalResources?: {
          /** @format uuid */
          id?: string;
          title: string;
          fileS3Key: string;
          fileS3Url?: string;
          fileName: string;
          fileNameToDownload: string | null;
          fileExtension?: string;
          /** @format date-time */
          createdAt?: string;
        }[];
        isFreemium?: boolean;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
    }[];
    courseLessonCount: number;
    isPublished?: boolean;
    /** @format date-time */
    createdAt?: string;
    hasFreeLesson?: boolean;
    teacherId: string;
    subjectId?: string;
    schoolClassId: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetStudentCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorEmail?: string;
    subject: string;
    chapters?: {
      /** @format uuid */
      id: string;
      title: string;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ";
        description?: string | null;
        status?: string;
        displayOrder: number;
        fileUrl?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "scale_1_5"
            | "single_choice"
            | "free_choice"
            | "multiple_choice"
            | "true_or_false"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd"
            | "sorting";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string | null;
          photoS3Key?: string | null;
          options?: {
            /** @format uuid */
            id?: string;
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean;
            /** @format uuid */
            questionId?: string;
            scaleAnswer?: number | null;
          }[];
        }[];
        /** @format date-time */
        updatedAt?: string;
        highlights?: {
          /** @format uuid */
          id?: string;
          title: string;
          photoS3Key?: string;
          photoS3Url?: string;
          timestamp: number;
        }[];
        additionalResources?: {
          /** @format uuid */
          id?: string;
          title: string;
          fileS3Key: string;
          fileS3Url?: string;
          fileName: string;
          fileNameToDownload: string | null;
          fileExtension?: string;
          /** @format date-time */
          createdAt?: string;
        }[];
        isFreemium?: boolean;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
    }[];
    courseLessonCount: number;
    isPublished?: boolean;
    /** @format date-time */
    createdAt?: string;
    hasFreeLesson?: boolean;
    teacherId: string;
    subjectId?: string;
    schoolClassId: string;
    completedLessonCount: number;
    quizCount: number;
    courseStatus: "not_started" | "in_progress" | "completed";
    isEnrolled: boolean;
    schoolClass?: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSubjectCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    lessons: {
      /** @format uuid */
      id: string;
      type: "VIDEO" | "TEXT" | "QUIZ";
      title: string;
      questionsCount: number | null;
      isFreemium: boolean;
      status: "not_started" | "in_progress" | "completed";
    }[];
    isEnrolled: boolean;
    hasFreeLesson: boolean;
  }[];
}

export interface GetStudentClassSelectionResponse {
  data: {
    id?: string | null;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId: string;
    subjectName: string;
    schoolClassName: string;
    teacherId?: string | null;
    isEnrolled?: boolean;
    hasStartedLessonForSubscription: boolean;
    hasFreeLesson: boolean;
    courseCount: number;
    completedCourseCount: number;
    lessonCount: number;
    lessonCountWithQuiz: number;
    completedLessonCountWithQuiz: number;
    inProgressCourseCount: number;
  }[];
}

export interface GetTrialStudentClassSelectionResponse {
  data: {
    id?: string | null;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId: string;
    subjectName: string;
    schoolClassName: string;
    teacherId?: string | null;
    isEnrolled?: boolean;
    hasStartedLessonForSubscription: boolean;
    hasFreeLesson: boolean;
    courseCount: number;
    completedCourseCount: number;
    lessonCount: number;
    lessonCountWithQuiz: number;
    completedLessonCountWithQuiz: number;
    inProgressCourseCount: number;
  }[];
}

export interface GetCourseResponse {
  data: {
    archived?: boolean;
    /** @format uuid */
    authorId: string;
    subject: string;
    /** @format uuid */
    schoolClassId: string;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    teacherId: string;
    chapter: {
      /** @format uuid */
      id: string;
      title: string;
      lessons: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ";
        displayOrder: number;
        isFreemium: boolean;
        status: "not_started" | "in_progress" | "completed";
        quizQuestionCount: number | null;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
      quizCount?: number;
    };
    completedLessonCount?: number;
    courseLessonCount: number;
    description: string;
    isEnrolled?: boolean;
    /** @format uuid */
    id: string;
    isPublished: boolean;
    isScorm?: boolean;
    thumbnailUrl?: string;
    title: string;
  };
}

export interface GetBetaCourseByIdResponse {
  data: {
    archived?: boolean;
    /** @format uuid */
    authorId: string;
    subject: string;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId?: string;
    /** @format uuid */
    teacherId: string;
    chapter: {
      /** @format uuid */
      id: string;
      title: string;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ";
        description?: string | null;
        status?: string;
        displayOrder: number;
        fileUrl?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "scale_1_5"
            | "single_choice"
            | "free_choice"
            | "multiple_choice"
            | "true_or_false"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd"
            | "sorting";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string | null;
          photoS3Key?: string | null;
          options?: {
            /** @format uuid */
            id?: string;
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean;
            /** @format uuid */
            questionId?: string;
            scaleAnswer?: number | null;
          }[];
        }[];
        /** @format date-time */
        updatedAt?: string;
        highlights?: {
          /** @format uuid */
          id?: string;
          title: string;
          photoS3Key?: string;
          photoS3Url?: string;
          timestamp: number;
        }[];
        additionalResources?: {
          /** @format uuid */
          id?: string;
          title: string;
          fileS3Key: string;
          fileS3Url?: string;
          fileName: string;
          fileNameToDownload: string | null;
          fileExtension?: string;
          /** @format date-time */
          createdAt?: string;
        }[];
        isFreemium?: boolean;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
    };
    completedLessonCount?: number;
    courseLessonCount: number;
    description: string;
    isEnrolled?: boolean;
    /** @format uuid */
    id: string;
    isPublished: boolean;
    isScorm?: boolean;
    thumbnailUrl?: string;
    thumbnailS3Key?: string;
    thumbnailS3SignedUrl?: string | null;
    title: string;
    displayOrder: number;
  };
}

export type CreateCourseBody = {
  title: string;
  description: string;
  isPublished?: boolean;
  thumbnailS3Key?: string;
  /** @format uuid */
  subjectId: string;
  isScorm?: boolean;
  /** @format uuid */
  schoolClassId: string;
  /** @format uuid */
  teacherId: string;
  displayOrder: number;
} & {
  chapters?: string[];
};

export interface CreateCourseResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateCourseBody {
  title?: string;
  description?: string;
  thumbnailS3Key?: string;
  isPublished?: boolean;
  /** @format uuid */
  subjectId?: string;
  /** @format uuid */
  teacherId?: string;
  /** @format uuid */
  schoolClassId?: string;
  chapters?: string[];
  archived?: boolean;
  displayOrder?: number;
}

export interface UpdateCourseResponse {
  data: {
    message: string;
  };
}

export interface EnrollCourseResponse {
  data: {
    message: string;
  };
}

export type UnenrollCourseResponse = null;

export type DeleteCourseResponse = null;

export type DeleteManyCoursesResponse = null;

export interface GetUserStatisticsResponse {
  data: {
    averageStats: {
      lessonStats: {
        started: number;
        completed: number;
        completionRate: number;
      };
      courseStats: {
        started: number;
        completed: number;
        completionRate: number;
      };
    };
    quizzes: {
      totalAttempts: number;
      totalCorrectAnswers: number;
      totalWrongAnswers: number;
      totalQuestions: number;
      averageScore: number;
      uniqueQuizzesTaken: number;
    };
    courses: object;
    lessons: object;
    streak: {
      current: number;
      longest: number;
      activityHistory: object;
    };
    nextLesson: {
      /** @format uuid */
      courseId: string;
      courseTitle: string;
      courseDescription: string;
      courseThumbnail: string;
      /** @format uuid */
      lessonId: string;
      chapterTitle: string;
      chapterProgress: "not_started" | "in_progress" | "completed";
      completedLessonCount: number;
      lessonCount: number;
      chapterDisplayOrder: number;
    } | null;
  };
}

export interface GetContentCreatorStatsResponse {
  data: {
    fiveMostPopularCourses: {
      courseName: string;
      studentCount: number;
    }[];
    totalCoursesCompletionStats: {
      completionPercentage: number;
      totalCoursesCompletion: number;
      totalCourses: number;
    };
    conversionAfterFreemiumLesson: {
      conversionPercentage: number;
      purchasedCourses: number;
      remainedOnFreemium: number;
    };
    courseStudentsStats: object;
    avgQuizScore: {
      correctAnswerCount: number;
      wrongAnswerCount: number;
      answerCount: number;
    };
  };
}

export interface GetLessonByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    type: "VIDEO" | "TEXT" | "QUIZ";
    description: string | null;
    fileUrl?: string | null;
    quizDetails?: {
      questions: {
        /** @format uuid */
        id: string;
        type:
          | "scale_1_5"
          | "single_choice"
          | "free_choice"
          | "multiple_choice"
          | "true_or_false"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd"
          | "sorting";
        description?: string | null;
        title: string;
        displayOrder?: number;
        solutionExplanation: string | null;
        photoS3Key?: string | null;
        options?: {
          /** @format uuid */
          id: string;
          optionText: string | null;
          displayOrder: number | null;
          isStudentAnswer: boolean | null;
          studentAnswer: string | null;
          isCorrect: boolean | null;
          /** @format uuid */
          questionId?: string;
        }[];
        passQuestion: boolean | null;
      }[];
      questionCount: number;
      correctAnswerCount: number | null;
      wrongAnswerCount: number | null;
      score: number | null;
    };
    lessonCompleted?: boolean;
    displayOrder: number;
    nextLessonId: string | null;
    highlights: {
      /** @format uuid */
      id?: string;
      title: string;
      photoS3Key?: string;
      photoS3Url?: string;
      timestamp: number;
    }[];
    additionalResources: {
      /** @format uuid */
      id?: string;
      title: string;
      fileS3Key: string;
      fileS3Url?: string;
      fileName: string;
      fileNameToDownload: string | null;
      fileExtension?: string;
      /** @format date-time */
      createdAt?: string;
    }[];
    isFreemium?: boolean;
  };
}

export type BetaCreateLessonBody = {
  title: string;
  type: "VIDEO" | "TEXT" | "QUIZ";
  description?: string | null;
  status?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    photoS3Key?: string | null;
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
  /** @format date-time */
  updatedAt?: string;
  highlights?: {
    /** @format uuid */
    id?: string;
    title: string;
    photoS3Key?: string;
    photoS3Url?: string;
    timestamp: number;
  }[];
  additionalResources?: {
    /** @format uuid */
    id?: string;
    title: string;
    fileS3Key: string;
    fileS3Url?: string;
    fileName: string;
    fileNameToDownload: string | null;
    fileExtension?: string;
    /** @format date-time */
    createdAt?: string;
  }[];
  isFreemium?: boolean;
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
};

export interface BetaCreateLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type BetaCreateQuizLessonBody = {
  title: string;
  type: "VIDEO" | "TEXT" | "QUIZ";
  description?: string;
  solutionExplanation?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    photoS3Key?: string | null;
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
};

export interface BetaCreateQuizLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type BetaUpdateQuizLessonBody = {
  title?: string;
  type?: "VIDEO" | "TEXT" | "QUIZ";
  description?: string;
  solutionExplanation?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    photoS3Key?: string | null;
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
} & {
  /** @format uuid */
  chapterId?: string;
  displayOrder?: number;
};

export interface BetaUpdateQuizLessonResponse {
  data: {
    message: string;
  };
}

export type BetaUpdateLessonBody = {
  title?: string;
  type?: "VIDEO" | "TEXT" | "QUIZ";
  description?: string | null;
  status?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    photoS3Key?: string | null;
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
  /** @format date-time */
  updatedAt?: string;
  highlights?: {
    /** @format uuid */
    id?: string;
    title: string;
    photoS3Key?: string;
    photoS3Url?: string;
    timestamp: number;
  }[];
  additionalResources?: {
    /** @format uuid */
    id?: string;
    title: string;
    fileS3Key: string;
    fileS3Url?: string;
    fileName: string;
    fileNameToDownload: string | null;
    fileExtension?: string;
    /** @format date-time */
    createdAt?: string;
  }[];
  isFreemium?: boolean;
} & {
  /** @format uuid */
  chapterId?: string;
  displayOrder?: number;
};

export interface BetaUpdateLessonResponse {
  data: {
    message: string;
  };
}

export interface RemoveLessonResponse {
  data: {
    message: string;
  };
}

export interface EvaluationQuizBody {
  /** @format uuid */
  lessonId: string;
  questionsAnswers: {
    /** @format uuid */
    questionId: string;
    answers: (
      | {
          /** @format uuid */
          answerId: string;
        }
      | {
          value: string;
        }
      | {
          /** @format uuid */
          answerId: string;
          value: string;
        }
    )[];
  }[];
}

export interface EvaluationQuizResponse {
  data: {
    message: string;
    data: {
      correctAnswerCount: number;
      wrongAnswerCount: number;
      questionCount: number;
      score: number;
    };
  };
}

export interface ClearQuizProgressBody {
  /** @format uuid */
  lessonId: string;
}

export interface ClearQuizProgressResponse {
  data: {
    message: string;
  };
}

export interface UpdateLessonDisplayOrderBody {
  /** @format uuid */
  lessonId: string;
  displayOrder: number;
}

export interface UpdateLessonDisplayOrderResponse {
  data: {
    message: string;
  };
}

export interface DownloadAdditionalResourceResponse {
  data: {
    message: string;
  };
}

export interface WatchVideoEventResponse {
  data: {
    message: string;
  };
}

export interface UpdateLessonVimeoThumbnailResponse {
  data: {
    message: string;
  };
}

export interface MarkLessonAsCompletedResponse {
  data: {
    /** @format uuid */
    lessonId: string;
    message: string;
  };
}

export interface GetVideoProgressResponse {
  data: {
    currentPosition: number;
    watchedDuration: number;
    lastUpdatedAt?: string;
  };
}

export interface GetVideoStatisticsResponse {
  data: {
    viewerCount: number;
  };
}

export interface GetStudentPreferencesResponse {
  data: {
    data: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      studentId: string;
      preferredSubject: string | null;
      classLevel: string | null;
      learningGoals: string[] | null;
      completedAt: string | null;
    };
    message: string;
  };
}

export interface CreateStudentPreferencesBody {
  preferredSubject: string;
  classLevel: string;
  learningGoals: string[];
}

export interface CreateStudentPreferencesResponse {
  data: {
    message: string;
  };
}

export interface GetAllSchoolClassesResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  }[];
}

export interface GetSchoolClassByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  };
}

export interface GetAllTeachersResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    firstName: string;
    lastName: string;
    description: string;
    profilePictureS3Key: string | null;
    subjectId: string | null;
    educationalMission: string;
    profilePictureS3SignedUrl: string | null;
    assignedCourseCount: number;
    subjectName: string | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetTeacherByIdResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    firstName: string;
    lastName: string;
    description: string;
    profilePictureS3Key: string | null;
    subjectId: string | null;
    educationalMission: string;
    profilePictureS3SignedUrl: string | null;
    subjectName: string;
  };
}

export interface CreateTeacherBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  firstName: string;
  lastName: string;
  description: string;
  profilePictureS3Key?: string | null;
  subjectId?: string | null;
  educationalMission: string;
}

export interface CreateTeacherResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateTeacherBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  firstName?: string;
  lastName?: string;
  description?: string;
  profilePictureS3Key?: string | null;
  subjectId?: string | null;
  educationalMission?: string;
}

export interface UpdateTeacherResponse {
  data: {
    message: string;
  };
}

export interface DeleteTeacherResponse {
  data: {
    message: string;
  };
}

export interface GetAllSubscriptionPlansResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    price: number;
    oldPrice: number | null;
    /** @format date-time */
    createdAt: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSubscriptionPlanByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    price: number;
    oldPrice: number | null;
    /** @format date-time */
    createdAt: string;
  };
}

export interface UpdateSubscriptionPlanBody {
  price?: number;
  oldPrice?: number;
}

export interface UpdateSubscriptionPlanResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    price: number;
    oldPrice: number | null;
    /** @format date-time */
    createdAt: string;
  };
}

export interface GetSubscriptionsByStudentIdResponse {
  data: {
    planName: string;
    status: string;
    amount: number;
    transactionId: string;
    subscriptions: {
      /** @format uuid */
      id: string;
      subject: string;
      className: string;
      startDate: string;
      endDate: string | null;
      cancellationDate: string | null;
      nextRenewalDate: string | null;
    }[];
  }[];
}

export interface GetGamificationBadgesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    name: string;
    badgeType: string;
    trophyType: string;
    tier: number;
    completedTierName: string;
    badgeAvatarId: string | null;
    description: string | null;
    descriptionAfterShare: string | null;
    subjectIds: string[] | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetGamificationBadgeByIdResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    name: string;
    badgeType: string;
    trophyType: string;
    tier: number;
    completedTierName: string;
    badgeAvatarId: string | null;
    description: string | null;
    descriptionAfterShare: string | null;
    subjectIds: string[] | null;
  };
}

export interface UpdateGamificationBadgeBody {
  name: string;
  description: string | null;
  descriptionAfterShare: string | null;
}

export interface UpdateGamificationBadgeResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    name: string;
    badgeType: string;
    trophyType: string;
    tier: number;
    completedTierName: string;
    badgeAvatarId: string | null;
    description: string | null;
    descriptionAfterShare: string | null;
    subjectIds: string[] | null;
  };
}

export interface GetUserAchievementsResponse {
  data: {
    id: string;
    name: string;
    badgeType:
      | "POWER_SIGN"
      | "LEARNING_TROPHY"
      | "BIDIRECTIONAL_TROPHY"
      | "INTERDISCIPLINARY_TROPHY";
    trophyType:
      | "STARTER"
      | "SOCIAL_MOTIVATOR"
      | "MOTIVATION_AMBASSADOR"
      | "LESSON_SPRINTER"
      | "DAILY_RECORD_HOLDER"
      | "VIRTUAL_EXPLORER"
      | "PERSISTENT_WANDERER"
      | "CONSTRUCTIVE_REVIEWER"
      | "MATH_MASTER"
      | "POLISH_MASTER"
      | "ENGLISH_MASTER"
      | "MATH_QUIZ_MARATHONER"
      | "POLISH_QUIZ_MARATHONER"
      | "ENGLISH_QUIZ_MARATHONER"
      | "MATH_PRECISE_MIND"
      | "POLISH_PRECISE_MIND"
      | "ENGLISH_PRECISE_MIND"
      | "MATH_FLAWLESS_MIND"
      | "POLISH_FLAWLESS_MIND"
      | "ENGLISH_FLAWLESS_MIND"
      | "MATH_VIDEO_ENTHUSIAST"
      | "POLISH_VIDEO_ENTHUSIAST"
      | "ENGLISH_VIDEO_ENTHUSIAST"
      | "MATH_DIDACTIC_COLLECTOR"
      | "POLISH_DIDACTIC_COLLECTOR"
      | "ENGLISH_DIDACTIC_COLLECTOR"
      | "TWO_SUBJECT_MASTER_MAT_ENG"
      | "TWO_SUBJECT_MASTER_MAT_POL"
      | "TWO_SUBJECT_MASTER_ENG_POL"
      | "TWO_SECTION_EXPERT_MAT_ENG"
      | "TWO_SECTION_EXPERT_MAT_POL"
      | "TWO_SECTION_EXPERT_ENG_POL"
      | "QUIZ_DUO_MAT_ENG"
      | "QUIZ_DUO_MAT_POL"
      | "QUIZ_DUO_ENG_POL"
      | "FLAWLESS_DUO_MAT_ENG"
      | "FLAWLESS_DUO_MAT_POL"
      | "FLAWLESS_DUO_ENG_POL"
      | "VIDEO_DUO_MAT_ENG"
      | "VIDEO_DUO_MAT_POL"
      | "VIDEO_DUO_ENG_POL"
      | "DIDACTIC_DUO_MAT_ENG"
      | "DIDACTIC_DUO_MAT_POL"
      | "DIDACTIC_DUO_ENG_POL"
      | "THREE_SUBJECT_MASTER"
      | "THREE_SECTION_EXPERT"
      | "QUIZ_TRIATHLON"
      | "FLAWLESS_TRIO"
      | "VIDEO_TRIAD"
      | "DIDACTIC_TRIAD";
    tier: number;
    badgeAvatarId: string | null;
    progress: number;
    requiredProgress: number;
  }[];
}

export interface CreateThreadResponse {
  threadId: string;
}

export interface CreateMessageBody {
  content: string;
}

export interface CreateMessageResponse {
  content: string;
  role: "system" | "user" | "assistant";
}

export type ListMessagesResponse = {
  content: string;
  role: "system" | "user" | "assistant";
}[];

export type GetUserThreadsResponse = {
  threadId: string;
  /** @format uuid */
  lessonId: string;
}[];

export interface GetThreadByLessonResponse {
  threadId: string | null;
}

export interface GetUserThreadIdResponse {
  userThreadId: string | null;
}

export interface CreateTransactionBody {
  /** @format uuid */
  userId: string;
  /** @min 1 */
  amount: number;
  /** @format email */
  email: string;
  description: string;
  subscriptionSubjectIds: string[];
  /** @format uuid */
  studentClassId: string;
  /** @format uuid */
  subscriptionPlanId: string;
  metadata: {
    /** @format uri */
    returnUrl: string;
  };
}

export interface CreateTransactionResponse {
  data: {
    sessionId: string;
    token: string;
    redirectUrl: string;
  };
}

export interface ChargeBlikBody {
  token: string;
  blikCode: string;
}

export interface ChargeBlikResponse {
  data: {
    status: string;
    message: string;
  };
}

export interface HandleP24NotificationBody {
  merchantId: number;
  posId: number;
  sessionId: string;
  amount: number;
  originAmount: number;
  currency: string;
  orderId: number;
  methodId: number;
  statement: string;
  sign: string;
}

export interface HandleP24NotificationResponse {
  data: object;
}

export interface SendToUserBody {
  event:
    | "notification"
    | "system_notification"
    | "payment_status_success"
    | "request_subscription_status"
    | "video_progress_update"
    | "new_system_message"
    | "achievement_awarded";
  message: string;
  type?: "info" | "warning" | "error" | "success";
}

export interface SendToUserResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export interface SendToRoleBody {
  event:
    | "notification"
    | "system_notification"
    | "payment_status_success"
    | "request_subscription_status"
    | "video_progress_update"
    | "new_system_message"
    | "achievement_awarded";
  message: string;
  type?: "info" | "warning" | "error" | "success";
}

export interface SendToRoleResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export interface SendToAllBody {
  event:
    | "notification"
    | "system_notification"
    | "payment_status_success"
    | "request_subscription_status"
    | "video_progress_update"
    | "new_system_message"
    | "achievement_awarded";
  message: string;
  type?: "info" | "warning" | "error" | "success";
}

export interface SendToAllResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export interface GetDiscountCodesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    usedAt: string | null;
    userId: string;
  }[];
}

export interface CreateDiscountCodeBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  /** @maxLength 200 */
  name: string;
  discountPercentage: number;
  expirationDate?: string | null;
  usedAt?: string | null;
  userId: string;
}

export interface CreateDiscountCodeResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    usedAt: string | null;
    userId: string;
  };
}

export interface GetUserFriendsInvitationsResponse {
  data: {
    id: string;
    createdAt: string;
    senderId: string;
    invitedEmail: string;
    message: string | null;
    accepted: boolean | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface CreateFriendInvitationBody {
  invitedEmail: string;
  message?: string;
}

export interface CreateFriendInvitationResponse {
  data: {
    message: string;
  };
}

export type Body = object;

export interface SearchResponse {
  data: {
    /** @format uuid */
    id: string;
    lessonTitle: string;
    description: string | null;
    vimeoThumbnailUrl: string | null;
    subjectName: string;
    /** @format uuid */
    subjectId: string;
    schoolClassName: string;
    /** @format uuid */
    schoolClassId: string;
    isFreemium: boolean;
    isEnrolled: boolean;
    /** @format uuid */
    courseId: string;
    courseName: string;
    courseLessonCount: number;
    lessonDisplayOrder: number;
  }[];
}

export interface SearchHistoryResponse {
  data: {
    /** @format uuid */
    id: string;
    lessonTitle: string;
    description: string | null;
    vimeoThumbnailUrl: string | null;
    subjectName: string;
    /** @format uuid */
    subjectId: string;
    schoolClassName: string;
    /** @format uuid */
    schoolClassId: string;
    isFreemium: boolean;
    isEnrolled: boolean;
    /** @format uuid */
    courseId: string;
    courseName: string;
    courseLessonCount: number;
    lessonDisplayOrder: number;
  }[];
}

export interface GetEventHistoryResponse {
  data: {
    /** @format uuid */
    id: string;
    author: string | null;
    eventType: string;
    affectedElementName: string;
    /** @format date-time */
    createdAt: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSystemMessagesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    authorId: string;
    title: string;
    content: string;
    targetRole: string | null;
    url: string | null;
    subjectId: string | null;
    schoolClassId: string | null;
    readCount: number;
    sentCount: number;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface CreateSystemMessageBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  content: string;
  targetRole?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  url?: string | null;
  /** @format uuid */
  subjectId?: string;
  /** @format uuid */
  schoolClassId?: string;
}

export interface CreateSystemMessageResponse {
  data: {
    message: string;
  };
}

export type GetUserSystemMessagesResponse = {
  /** @format uuid */
  id: string;
  title: string;
  content: string;
  read: boolean;
  url: string | null;
}[];

export interface MarkAllAsReadResponse {
  data: {
    message: string;
  };
}

export interface HasUnreadSystemMessageResponse {
  data: {
    hasUnreadSystemMessage: boolean;
  };
}

export interface GetPublishedFlashcardCategoriesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    subjectCode: ("MATH" | "POLISH" | "ENGLISH") | null;
    subjectTitle: string;
    schoolClassName: string;
    authorName: string;
    flashcardCount: number;
  }[];
}

export interface GetAllFlashcardCategoriesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    subjectCode: ("MATH" | "POLISH" | "ENGLISH") | null;
    subjectTitle: string;
    schoolClassName: string;
    authorName: string;
    flashcardCount: number;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetUserFavoriteFlashcardsResponse {
  data: ((({
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    answer: string;
    flashcardCategoryId: string;
    authorId: string;
    reverseImageS3Key: string | null;
  } & {
    authorName: string;
    isFavorite: boolean;
  }) & {
    imageUrl: string | null;
    reverseImageUrl: string | null;
  }) & {
    isCompleted: boolean;
    subjectCode: "MATH" | "POLISH" | "ENGLISH";
  })[];
}

export interface GetFlashcardCategoryResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
  };
}

export interface GetPublishedFlashcardsForCategoryStudentResponse {
  data: ((({
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    answer: string;
    flashcardCategoryId: string;
    authorId: string;
    reverseImageS3Key: string | null;
  } & {
    authorName: string;
    isFavorite: boolean;
  }) & {
    imageUrl: string | null;
    reverseImageUrl: string | null;
  }) & {
    isCompleted: boolean;
    subjectCode: "MATH" | "POLISH" | "ENGLISH";
  })[];
}

export interface GetFlashcardsForCategoryResponse {
  data: ({
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    answer: string;
    imageS3Key: string | null;
    flashcardCategoryId: string;
    authorId: string;
    reverseImageS3Key: string | null;
  } & {
    authorName: string;
    isFavorite: boolean;
  })[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetFlashcardResponse {
  data: ({
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    answer: string;
    imageS3Key: string | null;
    flashcardCategoryId: string;
    authorId: string;
    reverseImageS3Key: string | null;
  } & {
    authorName: string;
    isFavorite: boolean;
  }) & {
    imageUrl: string | null;
    reverseImageUrl: string | null;
  };
}

export interface CreateFlashcardCategoryBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  /** @maxLength 200 */
  title: string;
  subjectId: string;
  schoolClassId: string;
  isPublished?: boolean;
}

export interface CreateFlashcardCategoryResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
  };
}

export interface AddFavoriteFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface CompleteFlashcardResponse {
  data: {
    message: string;
  };
}

export interface CreateFlashcardBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  answer: string;
  imageS3Key?: string | null;
  flashcardCategoryId: string;
  reverseImageS3Key?: string | null;
}

export interface CreateFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateFlashcardCategoryBody {
  /** @maxLength 200 */
  title?: string;
  subjectId?: string;
  schoolClassId?: string;
}

export interface UpdateFlashcardCategoryResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
  };
}

export interface TogglePublishFlashcardCategoryResponse {
  data: boolean;
}

export interface UpdateFlashcardBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  answer: string;
  imageS3Key?: string | null;
  flashcardCategoryId: string;
  reverseImageS3Key?: string | null;
}

export interface UpdateFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface DeleteFlashcardCategoryResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface DeleteFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface RemoveFavoriteFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface ResetFlashcardProgressResponse {
  data: {
    message: string;
  };
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Guidebook API
 * @version 1.0
 * @contact
 *
 * Example usage of Swagger with Typebox
 */
export class API<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name FileControllerUploadFile
     * @request POST:/api/file
     */
    fileControllerUploadFile: (
      data: {
        /** @format binary */
        file?: File;
        /** Optional resource type */
        resource?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileUploadResponse, any>({
        path: `/api/file`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerDeleteFile
     * @request DELETE:/api/file
     */
    fileControllerDeleteFile: (
      query: {
        /** Key of the file to delete */
        fileKey: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/file`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUsers
     * @request GET:/api/user/all
     */
    userControllerGetUsers: (
      query?: {
        keyword?: string;
        role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
        authenticationType?: "EMAIL" | "GOOGLE" | "FACEBOOK" | "TIKTOK";
        group?: "STAFF" | "USERS";
        activationStatus?: "active" | "inactive";
        subjects?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUsersResponse, any>({
        path: `/api/user/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserById
     * @request GET:/api/user
     */
    userControllerGetUserById: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserByIdResponse, any>({
        path: `/api/user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateUser
     * @request PATCH:/api/user
     */
    userControllerUpdateUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: UpdateUserBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserResponse, any>({
        path: `/api/user`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteBulkUsers
     * @request DELETE:/api/user
     */
    userControllerDeleteBulkUsers: (data: DeleteBulkUsersBody, params: RequestParams = {}) =>
      this.request<DeleteBulkUsersResponse, any>({
        path: `/api/user`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerCreateUser
     * @request POST:/api/user
     */
    userControllerCreateUser: (data: CreateUserBody, params: RequestParams = {}) =>
      this.request<CreateUserResponse, any>({
        path: `/api/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerSentryTest
     * @request GET:/api/user/test-sentry
     */
    userControllerSentryTest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/user/test-sentry`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserAvatars
     * @request GET:/api/user/avatars
     */
    userControllerGetUserAvatars: (params: RequestParams = {}) =>
      this.request<GetUserAvatarsResponse, any>({
        path: `/api/user/avatars`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateUserAvatar
     * @request PATCH:/api/user/avatar
     */
    userControllerUpdateUserAvatar: (
      query?: {
        userAvatarId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserAvatarResponse, any>({
        path: `/api/user/avatar`,
        method: "PATCH",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserDetails
     * @request GET:/api/user/details
     */
    userControllerGetUserDetails: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserDetailsResponse, any>({
        path: `/api/user/details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpsertUserDetails
     * @request PATCH:/api/user/details
     */
    userControllerUpsertUserDetails: (data: UpsertUserDetailsBody, params: RequestParams = {}) =>
      this.request<UpsertUserDetailsResponse, any>({
        path: `/api/user/details`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpsertStudentDetails
     * @request PATCH:/api/user/student-details
     */
    userControllerUpsertStudentDetails: (
      data: UpsertStudentDetailsBody,
      params: RequestParams = {},
    ) =>
      this.request<UpsertStudentDetailsResponse, any>({
        path: `/api/user/student-details`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerAdminUpdateUser
     * @request PATCH:/api/user/admin
     */
    userControllerAdminUpdateUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: AdminUpdateUserBody,
      params: RequestParams = {},
    ) =>
      this.request<AdminUpdateUserResponse, any>({
        path: `/api/user/admin`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerBanUser
     * @request PATCH:/api/user/ban
     */
    userControllerBanUser: (data: BanUserBody, params: RequestParams = {}) =>
      this.request<BanUserResponse, any>({
        path: `/api/user/ban`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerChangePassword
     * @request PATCH:/api/user/change-password
     */
    userControllerChangePassword: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: ChangePasswordBody,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordResponse, any>({
        path: `/api/user/change-password`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerArchiveUser
     * @request PATCH:/api/user/archive
     */
    userControllerArchiveUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ArchiveUserResponse, any>({
        path: `/api/user/archive`,
        method: "PATCH",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteUser
     * @request DELETE:/api/user/user
     */
    userControllerDeleteUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserResponse, any>({
        path: `/api/user/user`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteUserById
     * @request DELETE:/api/user/user/{id}
     */
    userControllerDeleteUserById: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/user/user/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthGet
     * @request GET:/api/better-auth/*
     */
    betterAuthControllerHandleAuthGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthPost
     * @request POST:/api/better-auth/*
     */
    betterAuthControllerHandleAuthPost: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthPut
     * @request PUT:/api/better-auth/*
     */
    betterAuthControllerHandleAuthPut: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthDelete
     * @request DELETE:/api/better-auth/*
     */
    betterAuthControllerHandleAuthDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthPatch
     * @request PATCH:/api/better-auth/*
     */
    betterAuthControllerHandleAuthPatch: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthOptions
     * @request OPTIONS:/api/better-auth/*
     */
    betterAuthControllerHandleAuthOptions: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthHead
     * @request HEAD:/api/better-auth/*
     */
    betterAuthControllerHandleAuthHead: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "HEAD",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthSearch
     * @request SEARCH:/api/better-auth/*
     */
    betterAuthControllerHandleAuthSearch: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "SEARCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name HealthControllerCheck
     * @request GET:/api/healthcheck
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/api/healthcheck`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TestConfigControllerSetup
     * @request POST:/api/test-config/setup
     */
    testConfigControllerSetup: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/test-config/setup`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TestConfigControllerTeardown
     * @request POST:/api/test-config/teardown
     */
    testConfigControllerTeardown: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/test-config/teardown`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerGetAllSubjects
     * @request GET:/api/subject
     */
    subjectControllerGetAllSubjects: (
      query?: {
        title?: string;
        archived?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: "title" | "creationDate" | "-title" | "-creationDate";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllSubjectsResponse, any>({
        path: `/api/subject`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerCreateSubject
     * @request POST:/api/subject
     */
    subjectControllerCreateSubject: (data: CreateSubjectBody, params: RequestParams = {}) =>
      this.request<CreateSubjectResponse, any>({
        path: `/api/subject`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerGetSubjectById
     * @request GET:/api/subject/{id}
     */
    subjectControllerGetSubjectById: (id: string, params: RequestParams = {}) =>
      this.request<GetSubjectByIdResponse, any>({
        path: `/api/subject/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerUpdateSubject
     * @request PATCH:/api/subject/{id}
     */
    subjectControllerUpdateSubject: (
      id: string,
      data: UpdateSubjectBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubjectResponse, any>({
        path: `/api/subject/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetAllCourses
     * @request GET:/api/course/all
     */
    courseControllerGetAllCourses: (
      query?: {
        title?: string;
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        authorId?: string;
        "creationDateRange[0]"?: string;
        "creationDateRange[1]"?: string;
        sort?:
          | "title"
          | "subject"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-subject"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
        /** @min 1 */
        page?: number;
        perPage?: number;
        /** @format uuid */
        schoolClassId?: string;
        /** @format uuid */
        teacherId?: string;
        isPublished?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllCoursesResponse, any>({
        path: `/api/course/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetStudentCourses
     * @request GET:/api/course/get-student-courses
     */
    courseControllerGetStudentCourses: (
      query?: {
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        schoolClassId?: string;
        progressStatus?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?:
          | "title"
          | "subject"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-subject"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentCoursesResponse, any>({
        path: `/api/course/get-student-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetSubjectCourses
     * @request GET:/api/course/subject-courses
     */
    courseControllerGetSubjectCourses: (
      query: {
        subjectId: string;
        schoolClassId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSubjectCoursesResponse, any>({
        path: `/api/course/subject-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetStudentClassSelection
     * @request GET:/api/course/student-class-selection
     */
    courseControllerGetStudentClassSelection: (params: RequestParams = {}) =>
      this.request<GetStudentClassSelectionResponse, any>({
        path: `/api/course/student-class-selection`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetTrialStudentClassSelection
     * @request GET:/api/course/trial-student-class-selection
     */
    courseControllerGetTrialStudentClassSelection: (params: RequestParams = {}) =>
      this.request<GetTrialStudentClassSelectionResponse, any>({
        path: `/api/course/trial-student-class-selection`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourse
     * @request GET:/api/course
     */
    courseControllerGetCourse: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseResponse, any>({
        path: `/api/course`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerCreateCourse
     * @request POST:/api/course
     */
    courseControllerCreateCourse: (data: CreateCourseBody, params: RequestParams = {}) =>
      this.request<CreateCourseResponse, any>({
        path: `/api/course`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetBetaCourseById
     * @request GET:/api/course/beta-course-by-id
     */
    courseControllerGetBetaCourseById: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetBetaCourseByIdResponse, any>({
        path: `/api/course/beta-course-by-id`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUpdateCourse
     * @request PATCH:/api/course/{id}
     */
    courseControllerUpdateCourse: (
      id: string,
      data: UpdateCourseBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCourseResponse, any>({
        path: `/api/course/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerEnrollCourse
     * @request POST:/api/course/enroll-course
     */
    courseControllerEnrollCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EnrollCourseResponse, any>({
        path: `/api/course/enroll-course`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUnpublishCourse
     * @request PATCH:/api/course/unpublish/{id}
     */
    courseControllerUnpublishCourse: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/course/unpublish/${id}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUnenrollCourse
     * @request DELETE:/api/course/unenroll-course
     */
    courseControllerUnenrollCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UnenrollCourseResponse, any>({
        path: `/api/course/unenroll-course`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDeleteCourse
     * @request DELETE:/api/course/remove
     */
    courseControllerDeleteCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteCourseResponse, any>({
        path: `/api/course/remove`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDeleteManyCourses
     * @request DELETE:/api/course/remove-many-courses
     */
    courseControllerDeleteManyCourses: (
      query?: {
        ids?: string | string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteManyCoursesResponse, any>({
        path: `/api/course/remove-many-courses`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetUserStatistics
     * @request GET:/api/statistics/user-stats
     */
    statisticsControllerGetUserStatistics: (params: RequestParams = {}) =>
      this.request<GetUserStatisticsResponse, any>({
        path: `/api/statistics/user-stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetContentCreatorStats
     * @request GET:/api/statistics/content-creator-stats
     */
    statisticsControllerGetContentCreatorStats: (params: RequestParams = {}) =>
      this.request<GetContentCreatorStatsResponse, any>({
        path: `/api/statistics/content-creator-stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessonById
     * @request GET:/api/lesson/{id}
     */
    lessonControllerGetLessonById: (id: string, params: RequestParams = {}) =>
      this.request<GetLessonByIdResponse, any>({
        path: `/api/lesson/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateLesson
     * @request POST:/api/lesson/beta-create-lesson
     */
    lessonControllerBetaCreateLesson: (data: BetaCreateLessonBody, params: RequestParams = {}) =>
      this.request<BetaCreateLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateQuizLesson
     * @request POST:/api/lesson/beta-create-lesson/quiz
     */
    lessonControllerBetaCreateQuizLesson: (
      data: BetaCreateQuizLessonBody,
      params: RequestParams = {},
    ) =>
      this.request<BetaCreateQuizLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson/quiz`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateQuizLesson
     * @request PATCH:/api/lesson/beta-update-lesson/quiz
     */
    lessonControllerBetaUpdateQuizLesson: (
      data: BetaUpdateQuizLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateQuizLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson/quiz`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateLesson
     * @request PATCH:/api/lesson/beta-update-lesson
     */
    lessonControllerBetaUpdateLesson: (
      data: BetaUpdateLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerRemoveLesson
     * @request DELETE:/api/lesson
     */
    lessonControllerRemoveLesson: (
      query: {
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RemoveLessonResponse, any>({
        path: `/api/lesson`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerEvaluationQuiz
     * @request POST:/api/lesson/evaluation-quiz
     */
    lessonControllerEvaluationQuiz: (data: EvaluationQuizBody, params: RequestParams = {}) =>
      this.request<EvaluationQuizResponse, any>({
        path: `/api/lesson/evaluation-quiz`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerClearQuizProgress
     * @request DELETE:/api/lesson/clear-quiz-progress
     */
    lessonControllerClearQuizProgress: (data: ClearQuizProgressBody, params: RequestParams = {}) =>
      this.request<ClearQuizProgressResponse, any>({
        path: `/api/lesson/clear-quiz-progress`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateLessonDisplayOrder
     * @request PATCH:/api/lesson/update-lesson-display-order
     */
    lessonControllerUpdateLessonDisplayOrder: (
      data: UpdateLessonDisplayOrderBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateLessonDisplayOrderResponse, any>({
        path: `/api/lesson/update-lesson-display-order`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerDownloadAdditionalResource
     * @request POST:/api/lesson/resource/{id}/download
     */
    lessonControllerDownloadAdditionalResource: (id: string, params: RequestParams = {}) =>
      this.request<DownloadAdditionalResourceResponse, any>({
        path: `/api/lesson/resource/${id}/download`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerWatchVideoEvent
     * @request POST:/api/lesson/watch-video/{id}
     */
    lessonControllerWatchVideoEvent: (id: string, params: RequestParams = {}) =>
      this.request<WatchVideoEventResponse, any>({
        path: `/api/lesson/watch-video/${id}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateLessonVimeoThumbnail
     * @request PATCH:/api/lesson/vimeo-thumbnail-update
     */
    lessonControllerUpdateLessonVimeoThumbnail: (
      query: {
        vimeoThumbnailS3Key: string;
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateLessonVimeoThumbnailResponse, any>({
        path: `/api/lesson/vimeo-thumbnail-update`,
        method: "PATCH",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentLessonProgressControllerMarkLessonAsCompleted
     * @request POST:/api/studentLessonProgress
     */
    studentLessonProgressControllerMarkLessonAsCompleted: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarkLessonAsCompletedResponse, any>({
        path: `/api/studentLessonProgress`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VideoLessonMetadataControllerGetVideoProgress
     * @request GET:/api/video-lesson-metadata/video-progress
     */
    videoLessonMetadataControllerGetVideoProgress: (
      query?: {
        /** @format uuid */
        lessonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVideoProgressResponse, any>({
        path: `/api/video-lesson-metadata/video-progress`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VideoLessonMetadataControllerGetVideoStatistics
     * @request GET:/api/video-lesson-metadata/video-statistics
     */
    videoLessonMetadataControllerGetVideoStatistics: (
      query?: {
        /** @format uuid */
        lessonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVideoStatisticsResponse, any>({
        path: `/api/video-lesson-metadata/video-statistics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentPreferencesControllerGetStudentPreferences
     * @request GET:/api/student-preferences
     */
    studentPreferencesControllerGetStudentPreferences: (params: RequestParams = {}) =>
      this.request<GetStudentPreferencesResponse, any>({
        path: `/api/student-preferences`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentPreferencesControllerCreateStudentPreferences
     * @request POST:/api/student-preferences
     */
    studentPreferencesControllerCreateStudentPreferences: (
      data: CreateStudentPreferencesBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateStudentPreferencesResponse, any>({
        path: `/api/student-preferences`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SchoolClassControllerGetAllSchoolClasses
     * @request GET:/api/school-class
     */
    schoolClassControllerGetAllSchoolClasses: (params: RequestParams = {}) =>
      this.request<GetAllSchoolClassesResponse, any>({
        path: `/api/school-class`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SchoolClassControllerGetSchoolClassById
     * @request GET:/api/school-class/{id}
     */
    schoolClassControllerGetSchoolClassById: (id: string, params: RequestParams = {}) =>
      this.request<GetSchoolClassByIdResponse, any>({
        path: `/api/school-class/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerGetAllTeachers
     * @request GET:/api/teachers/all
     */
    teachersControllerGetAllTeachers: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllTeachersResponse, any>({
        path: `/api/teachers/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerGetTeacherById
     * @request GET:/api/teachers/{id}
     */
    teachersControllerGetTeacherById: (id: string, params: RequestParams = {}) =>
      this.request<GetTeacherByIdResponse, any>({
        path: `/api/teachers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerUpdateTeacher
     * @request PATCH:/api/teachers/{id}
     */
    teachersControllerUpdateTeacher: (
      id: string,
      data: UpdateTeacherBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTeacherResponse, any>({
        path: `/api/teachers/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerDeleteTeacher
     * @request DELETE:/api/teachers/{id}
     */
    teachersControllerDeleteTeacher: (id: string, params: RequestParams = {}) =>
      this.request<DeleteTeacherResponse, any>({
        path: `/api/teachers/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerCreateTeacher
     * @request POST:/api/teachers
     */
    teachersControllerCreateTeacher: (data: CreateTeacherBody, params: RequestParams = {}) =>
      this.request<CreateTeacherResponse, any>({
        path: `/api/teachers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionPlanControllerGetAllSubscriptionPlans
     * @request GET:/api/subscriptionPlan
     */
    subscriptionPlanControllerGetAllSubscriptionPlans: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: "name" | "schoolClass" | "creationDate" | "-name" | "-schoolClass" | "-creationDate";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllSubscriptionPlansResponse, any>({
        path: `/api/subscriptionPlan`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionPlanControllerGetSubscriptionPlanById
     * @request GET:/api/subscriptionPlan/{id}
     */
    subscriptionPlanControllerGetSubscriptionPlanById: (id: string, params: RequestParams = {}) =>
      this.request<GetSubscriptionPlanByIdResponse, any>({
        path: `/api/subscriptionPlan/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionPlanControllerUpdateSubscriptionPlan
     * @request PATCH:/api/subscriptionPlan/{id}
     */
    subscriptionPlanControllerUpdateSubscriptionPlan: (
      id: string,
      data: UpdateSubscriptionPlanBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionPlanResponse, any>({
        path: `/api/subscriptionPlan/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerGetSubscriptionsByStudentId
     * @request GET:/api/subscription/student/{studentId}
     */
    subscriptionControllerGetSubscriptionsByStudentId: (
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetSubscriptionsByStudentIdResponse, any>({
        path: `/api/subscription/student/${studentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetGamificationBadges
     * @request GET:/api/gamification/gamification-badges
     */
    gamificationControllerGetGamificationBadges: (
      query?: {
        types?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGamificationBadgesResponse, any>({
        path: `/api/gamification/gamification-badges`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetGamificationBadgeById
     * @request GET:/api/gamification/gamification-badge/{id}
     */
    gamificationControllerGetGamificationBadgeById: (id: string, params: RequestParams = {}) =>
      this.request<GetGamificationBadgeByIdResponse, any>({
        path: `/api/gamification/gamification-badge/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerUpdateGamificationBadge
     * @request PATCH:/api/gamification/gamification-badge/{id}
     */
    gamificationControllerUpdateGamificationBadge: (
      id: string,
      data: UpdateGamificationBadgeBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateGamificationBadgeResponse, any>({
        path: `/api/gamification/gamification-badge/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetUserAchievements
     * @request GET:/api/gamification/user-achievements
     */
    gamificationControllerGetUserAchievements: (
      query?: {
        badgeType?:
          | "POWER_SIGN"
          | "LEARNING_TROPHY"
          | "BIDIRECTIONAL_TROPHY"
          | "INTERDISCIPLINARY_TROPHY";
        isAchieved?: "true" | "false";
        tier?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserAchievementsResponse, any>({
        path: `/api/gamification/user-achievements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerCreateThread
     * @request POST:/api/threads/lesson/{lessonId}
     */
    chatBotControllerCreateThread: (lessonId: string, params: RequestParams = {}) =>
      this.request<CreateThreadResponse, any>({
        path: `/api/threads/lesson/${lessonId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerCreateMessage
     * @request POST:/api/threads/{threadId}/messages
     */
    chatBotControllerCreateMessage: (
      threadId: string,
      data: CreateMessageBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateMessageResponse, any>({
        path: `/api/threads/${threadId}/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerListMessages
     * @request GET:/api/threads/{threadId}/messages
     */
    chatBotControllerListMessages: (threadId: string, params: RequestParams = {}) =>
      this.request<ListMessagesResponse, any>({
        path: `/api/threads/${threadId}/messages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerHealthCheck
     * @request GET:/api/threads/health
     */
    chatBotControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/threads/health`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetUserThreads
     * @request GET:/api/threads/user-threads
     */
    chatBotControllerGetUserThreads: (params: RequestParams = {}) =>
      this.request<GetUserThreadsResponse, any>({
        path: `/api/threads/user-threads`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetThreadByLesson
     * @request GET:/api/threads/lesson/{lessonId}/thread
     */
    chatBotControllerGetThreadByLesson: (lessonId: string, params: RequestParams = {}) =>
      this.request<GetThreadByLessonResponse, any>({
        path: `/api/threads/lesson/${lessonId}/thread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetUserThreadId
     * @request GET:/api/threads/user-thread
     */
    chatBotControllerGetUserThreadId: (params: RequestParams = {}) =>
      this.request<GetUserThreadIdResponse, any>({
        path: `/api/threads/user-thread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerCreateTransaction
     * @request POST:/api/p24/create
     */
    p24ControllerCreateTransaction: (data: CreateTransactionBody, params: RequestParams = {}) =>
      this.request<CreateTransactionResponse, any>({
        path: `/api/p24/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerChargeBlik
     * @request POST:/api/p24/blik/charge
     */
    p24ControllerChargeBlik: (data: ChargeBlikBody, params: RequestParams = {}) =>
      this.request<ChargeBlikResponse, any>({
        path: `/api/p24/blik/charge`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerHandleP24Notification
     * @request POST:/api/p24/status
     */
    p24ControllerHandleP24Notification: (
      data: HandleP24NotificationBody,
      params: RequestParams = {},
    ) =>
      this.request<HandleP24NotificationResponse, any>({
        path: `/api/p24/status`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebsocketControllerSendToUser
     * @request POST:/api/websocket/send-to-user/{userId}
     */
    websocketControllerSendToUser: (
      userId: string,
      data: SendToUserBody,
      params: RequestParams = {},
    ) =>
      this.request<SendToUserResponse, any>({
        path: `/api/websocket/send-to-user/${userId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebsocketControllerSendToRole
     * @request POST:/api/websocket/send-to-role/{role}
     */
    websocketControllerSendToRole: (
      role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN",
      data: SendToRoleBody,
      params: RequestParams = {},
    ) =>
      this.request<SendToRoleResponse, any>({
        path: `/api/websocket/send-to-role/${role}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebsocketControllerSendToAll
     * @request POST:/api/websocket/send-to-all
     */
    websocketControllerSendToAll: (data: SendToAllBody, params: RequestParams = {}) =>
      this.request<SendToAllResponse, any>({
        path: `/api/websocket/send-to-all`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DiscountCodesControllerGetDiscountCodes
     * @request GET:/api/discount-codes
     */
    discountCodesControllerGetDiscountCodes: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDiscountCodesResponse, any>({
        path: `/api/discount-codes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DiscountCodesControllerCreateDiscountCode
     * @request POST:/api/discount-codes
     */
    discountCodesControllerCreateDiscountCode: (
      data: CreateDiscountCodeBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateDiscountCodeResponse, any>({
        path: `/api/discount-codes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FriendInvitationsControllerGetUserFriendsInvitations
     * @request GET:/api/friend-invitations
     */
    friendInvitationsControllerGetUserFriendsInvitations: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserFriendsInvitationsResponse, any>({
        path: `/api/friend-invitations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FriendInvitationsControllerCreateFriendInvitation
     * @request POST:/api/friend-invitations
     */
    friendInvitationsControllerCreateFriendInvitation: (
      data: CreateFriendInvitationBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateFriendInvitationResponse, any>({
        path: `/api/friend-invitations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerCreateIndex
     * @request POST:/api/opensearch/create-index
     */
    opensearchControllerCreateIndex: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/create-index`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerCreateCustomIndex
     * @request POST:/api/opensearch/create-custom-index
     */
    opensearchControllerCreateCustomIndex: (
      query: {
        index: string;
      },
      data: Body,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/create-custom-index`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerImportLessonsToDocuments
     * @request POST:/api/opensearch/import-lessons-to-documents
     */
    opensearchControllerImportLessonsToDocuments: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/import-lessons-to-documents`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerSearch
     * @request GET:/api/opensearch/search
     */
    opensearchControllerSearch: (
      query: {
        index: string;
        phrase: string;
        schoolClasses?: string[];
        subjects?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResponse, any>({
        path: `/api/opensearch/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerSearchPaginated
     * @request GET:/api/opensearch/search-paginated
     */
    opensearchControllerSearchPaginated: (
      query: {
        index: string;
        page: number;
        pageSize: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/search-paginated`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerSearchHistory
     * @request GET:/api/opensearch/search-history
     */
    opensearchControllerSearchHistory: (params: RequestParams = {}) =>
      this.request<SearchHistoryResponse, any>({
        path: `/api/opensearch/search-history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerAddSearchHistory
     * @request POST:/api/opensearch/add-search-history
     */
    opensearchControllerAddSearchHistory: (
      query: {
        phrase: string;
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/add-search-history`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerDeleteIndex
     * @request DELETE:/api/opensearch/delete-index
     */
    opensearchControllerDeleteIndex: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/delete-index`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerAutoReloadIndex
     * @request POST:/api/opensearch/auto-reload-index
     */
    opensearchControllerAutoReloadIndex: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/auto-reload-index`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventHistoryControllerGetEventHistory
     * @request GET:/api/event-history
     */
    eventHistoryControllerGetEventHistory: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetEventHistoryResponse, any>({
        path: `/api/event-history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerGetSystemMessages
     * @request GET:/api/system-messages
     */
    systemMessageControllerGetSystemMessages: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSystemMessagesResponse, any>({
        path: `/api/system-messages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerCreateSystemMessage
     * @request POST:/api/system-messages
     */
    systemMessageControllerCreateSystemMessage: (
      data: CreateSystemMessageBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateSystemMessageResponse, any>({
        path: `/api/system-messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerGetUserSystemMessages
     * @request GET:/api/system-messages/user-system-messages
     */
    systemMessageControllerGetUserSystemMessages: (params: RequestParams = {}) =>
      this.request<GetUserSystemMessagesResponse, any>({
        path: `/api/system-messages/user-system-messages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerMarkAllAsRead
     * @request PATCH:/api/system-messages/mark-all-as-read
     */
    systemMessageControllerMarkAllAsRead: (params: RequestParams = {}) =>
      this.request<MarkAllAsReadResponse, any>({
        path: `/api/system-messages/mark-all-as-read`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerHasUnreadSystemMessage
     * @request GET:/api/system-messages/has-unread
     */
    systemMessageControllerHasUnreadSystemMessage: (params: RequestParams = {}) =>
      this.request<HasUnreadSystemMessageResponse, any>({
        path: `/api/system-messages/has-unread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetPublishedFlashcardCategories
     * @request GET:/api/flashcards/published-flashcard-categories
     */
    flashcardsControllerGetPublishedFlashcardCategories: (
      query?: {
        subjectIds?: string[];
        schoolClassIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPublishedFlashcardCategoriesResponse, any>({
        path: `/api/flashcards/published-flashcard-categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetAllFlashcardCategories
     * @request GET:/api/flashcards/flashcard-categories
     */
    flashcardsControllerGetAllFlashcardCategories: (
      query?: {
        title?: string;
        /** @format uuid */
        authorId?: string;
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        schoolClassId?: string;
        isPublished?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllFlashcardCategoriesResponse, any>({
        path: `/api/flashcards/flashcard-categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerCreateFlashcardCategory
     * @request POST:/api/flashcards/flashcard-categories
     */
    flashcardsControllerCreateFlashcardCategory: (
      data: CreateFlashcardCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetUserFavoriteFlashcards
     * @request GET:/api/flashcards/user-favorite-flashcards
     */
    flashcardsControllerGetUserFavoriteFlashcards: (params: RequestParams = {}) =>
      this.request<GetUserFavoriteFlashcardsResponse, any>({
        path: `/api/flashcards/user-favorite-flashcards`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetFlashcardCategory
     * @request GET:/api/flashcards/flashcard-categories/{flashcardCategoryId}
     */
    flashcardsControllerGetFlashcardCategory: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/${flashcardCategoryId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerDeleteFlashcardCategory
     * @request DELETE:/api/flashcards/flashcard-categories/{flashcardCategoryId}
     */
    flashcardsControllerDeleteFlashcardCategory: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/${flashcardCategoryId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetPublishedFlashcardsForCategoryStudent
     * @request GET:/api/flashcards/in-category/student
     */
    flashcardsControllerGetPublishedFlashcardsForCategoryStudent: (
      query?: {
        /** @format uuid */
        categoryId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPublishedFlashcardsForCategoryStudentResponse, any>({
        path: `/api/flashcards/in-category/student`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetFlashcardsForCategory
     * @request GET:/api/flashcards/in-category
     */
    flashcardsControllerGetFlashcardsForCategory: (
      query?: {
        /** @format uuid */
        categoryId?: string;
        title?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFlashcardsForCategoryResponse, any>({
        path: `/api/flashcards/in-category`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetFlashcard
     * @request GET:/api/flashcards/{id}
     */
    flashcardsControllerGetFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<GetFlashcardResponse, any>({
        path: `/api/flashcards/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerUpdateFlashcard
     * @request PATCH:/api/flashcards/{id}
     */
    flashcardsControllerUpdateFlashcard: (
      id: string,
      data: UpdateFlashcardBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFlashcardResponse, any>({
        path: `/api/flashcards/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerDeleteFlashcard
     * @request DELETE:/api/flashcards/{id}
     */
    flashcardsControllerDeleteFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<DeleteFlashcardResponse, any>({
        path: `/api/flashcards/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerAddFavoriteFlashcard
     * @request POST:/api/flashcards/{id}/favorite
     */
    flashcardsControllerAddFavoriteFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<AddFavoriteFlashcardResponse, any>({
        path: `/api/flashcards/${id}/favorite`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerRemoveFavoriteFlashcard
     * @request DELETE:/api/flashcards/{id}/favorite
     */
    flashcardsControllerRemoveFavoriteFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<RemoveFavoriteFlashcardResponse, any>({
        path: `/api/flashcards/${id}/favorite`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerCompleteFlashcard
     * @request POST:/api/flashcards/progress/{flashcardCategoryId}/flashcard/{flashcardId}/complete
     */
    flashcardsControllerCompleteFlashcard: (
      flashcardCategoryId: string,
      flashcardId: string,
      params: RequestParams = {},
    ) =>
      this.request<CompleteFlashcardResponse, any>({
        path: `/api/flashcards/progress/${flashcardCategoryId}/flashcard/${flashcardId}/complete`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerCreateFlashcard
     * @request POST:/api/flashcards
     */
    flashcardsControllerCreateFlashcard: (data: CreateFlashcardBody, params: RequestParams = {}) =>
      this.request<CreateFlashcardResponse, any>({
        path: `/api/flashcards`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerUpdateFlashcardCategory
     * @request PATCH:/api/flashcards/flashcard-categories/edit/{flashcardCategoryId}
     */
    flashcardsControllerUpdateFlashcardCategory: (
      flashcardCategoryId: string,
      data: UpdateFlashcardCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/edit/${flashcardCategoryId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerTogglePublishFlashcardCategory
     * @request PATCH:/api/flashcards/flashcard-categories/toggle-publish/{flashcardCategoryId}
     */
    flashcardsControllerTogglePublishFlashcardCategory: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<TogglePublishFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/toggle-publish/${flashcardCategoryId}`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerResetFlashcardProgress
     * @request DELETE:/api/flashcards/progress/{flashcardCategoryId}
     */
    flashcardsControllerResetFlashcardProgress: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<ResetFlashcardProgressResponse, any>({
        path: `/api/flashcards/progress/${flashcardCategoryId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
}
